export default "__VITE_ASSET__DBAmX5ZL__"